__turbopack_context__.v({
  "loadMoreTrigger": "aiQX6W_loadMoreTrigger",
  "loader": "aiQX6W_loader",
  "reviewsBento": "aiQX6W_reviewsBento",
  "reviewsContainer": "aiQX6W_reviewsContainer",
  "reviewsHeader": "aiQX6W_reviewsHeader",
  "reviewsPlaceholder": "aiQX6W_reviewsPlaceholder",
  "reviewsTitle": "aiQX6W_reviewsTitle",
  "root": "aiQX6W_root",
  "scrollTopButton": "aiQX6W_scrollTopButton",
  "spin": "aiQX6W_spin",
});
